var MEBIBYTE = 1024 * 1024;

// Keep browser-side validation aligned with the server. These are fixed limits
// so an on-premise deployment does not need additional environment variables.
var MAX_COMPRESSED_IMPORT_BYTES = 16 * MEBIBYTE;
var MAX_UNCOMPRESSED_IMPORT_BYTES = 48 * MEBIBYTE;

function formatBytes(bytes) {
  if (bytes % MEBIBYTE === 0) {
    return (bytes / MEBIBYTE) + ' MiB';
  }
  return bytes + ' bytes';
}

function maximumBytesForUpload(isCompressed) {
  return isCompressed ? MAX_COMPRESSED_IMPORT_BYTES : MAX_UNCOMPRESSED_IMPORT_BYTES;
}

function validateByteLength(byteLength, isCompressed) {
  var bytes = Number(byteLength);
  var maximum = maximumBytesForUpload(isCompressed);
  if (!Number.isFinite(bytes) || bytes < 0 || bytes <= maximum) return null;

  var label = isCompressed ? 'Compressed' : 'Uncompressed';
  return new Error(label + ' import files must be ' + formatBytes(maximum) + ' or smaller.');
}

module.exports = {
  MAX_COMPRESSED_IMPORT_BYTES: MAX_COMPRESSED_IMPORT_BYTES,
  MAX_UNCOMPRESSED_IMPORT_BYTES: MAX_UNCOMPRESSED_IMPORT_BYTES,
  maximumBytesForUpload: maximumBytesForUpload,
  validateByteLength: validateByteLength
};
